export default __webpack_public_path__ + "static/media/poll-time-active-icon.9860db77.svg";